// Injects color-scheme hints into an email HTML document so dark-mode mail
// clients (Apple Mail / iOS Mail) stop auto-inverting our intentional colors.
// Unlayer exports a full HTML document but does not include these, which causes
// dark sections to be flipped to light in dark mode.

const COLOR_SCHEME_META = `<meta name="color-scheme" content="light dark" />
<meta name="supported-color-schemes" content="light dark" />`;

const COLOR_SCHEME_STYLE = `<style>
  :root { color-scheme: light dark; supported-color-schemes: light dark; }
</style>`;

export const applyDarkModeFix = (html) => {
  if (!html || typeof html !== "string") return html;

  // Idempotent: skip if we've already injected the hints.
  if (html.includes('name="color-scheme"')) return html;

  const injection = `${COLOR_SCHEME_META}\n${COLOR_SCHEME_STYLE}`;

  // Preferred: insert right after the opening <head> tag.
  const headMatch = html.match(/<head[^>]*>/i);
  if (headMatch) {
    const index = headMatch.index + headMatch[0].length;
    return html.slice(0, index) + "\n" + injection + html.slice(index);
  }

  // Fallback: before </head>.
  if (/<\/head>/i.test(html)) {
    return html.replace(/<\/head>/i, `${injection}\n</head>`);
  }

  // Last resort: before <body> or at the start.
  if (/<body[^>]*>/i.test(html)) {
    return html.replace(/(<body[^>]*>)/i, `${injection}\n$1`);
  }

  return injection + "\n" + html;
};
